import { render } from "./IqraSubstituteSessions.vue?vue&type=template&id=00d27801"
import script from "./IqraSubstituteSessions.vue?vue&type=script&lang=js"
export * from "./IqraSubstituteSessions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__